import { WorkspaceSidebarScaffold } from '../components/WorkspaceSidebarScaffold'
import { SidebarInset, SidebarProvider } from '@/shared/components/ui/sidebar'
import React, { JSX } from 'react'

type WorkspaceLayoutProps = {
    children: React.ReactNode
    optionBar?: React.ReactNode
    SidebarComponent?: React.ReactNode
    ProviderWrapper?: ({ children }: { children: React.ReactNode }) => JSX.Element
}

export const WorkspaceLayout = ({
    children,
    optionBar,
    ProviderWrapper,
    SidebarComponent,
}: WorkspaceLayoutProps) => {

    const content = (
        <>
            {SidebarComponent ?? <WorkspaceSidebarScaffold />}
            <SidebarInset>{children}</SidebarInset>
            {optionBar ?? <></>}
        </>
    )

    const WrappedContent = ProviderWrapper ? <ProviderWrapper>{content}</ProviderWrapper> : content

    return (
        <SidebarProvider>{WrappedContent}</SidebarProvider>
    )
}

